var _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path4, _path5, _rect10, _rect11, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 76,
    viewBox: "0 0 54 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 76H34C34.5523 76 35 75.5523 35 75V69C35 68.4477 34.5523 68 34 68H27V76Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76H20C19.4477 76 19 75.5523 19 75V69C19 68.4477 19.4477 68 20 68H27V76Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 7,
    width: 14,
    height: 2,
    transform: "rotate(-180 34 7)",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 0C24.5962 0 22.493 0.903226 22.0798 1.48387C20.9155 0.709677 20.0141 0.290323 19.6761 0.290323C19.338 0.290323 19 0.483871 19 0.677419V4.25806C19.0376 4.49462 19.293 4.97419 20.0141 5H27H33.9859C34.707 4.97419 34.9624 4.49462 35 4.25806V0.677419C35 0.483871 34.662 0.290323 34.3239 0.290323C33.9859 0.290323 33.0845 0.709677 31.9202 1.48387C31.507 0.903226 29.4038 0 27 0Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 15,
    width: 14,
    height: 7,
    transform: "rotate(-180 34 15)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 22,
    width: 14,
    height: 6,
    transform: "rotate(-180 34 22)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 8,
    width: 12,
    height: 0.999999,
    transform: "rotate(-180 33 8)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 12,
    height: 0.999999,
    transform: "rotate(-180 33 16)",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 23,
    width: 12,
    height: 0.999999,
    transform: "rotate(-180 33 23)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 46,
    width: 22,
    height: 22,
    rx: 2,
    transform: "rotate(-180 38 46)",
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8,
    rx: 1,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 47 37)",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 37,
    width: 14,
    height: 8,
    rx: 1,
    transform: "rotate(-90 7 37)",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 67H34C34.5523 67 35 66.5523 35 66V61C35 60.4477 34.5523 60 34 60H27V67Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 67H20C19.4477 67 19 66.5523 19 66V61C19 60.4477 19.4477 60 20 60H27V67Z",
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 6,
    rx: 1,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 54 37)",
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 37,
    width: 14,
    height: 6,
    rx: 1,
    transform: "rotate(-90 0 37)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 39V45.7344C48 45.9085 47.9546 46.0795 47.8682 46.2306L40.2879 59.4961C40.1099 59.8077 39.7785 60 39.4197 60H37C36.4477 60 36 60.4477 36 61V65C36 65.5523 36.4477 66 37 66H42.9101C43.2741 66 43.6093 65.8022 43.7853 65.4837L53.8752 47.2258C53.9571 47.0777 54 46.9113 54 46.7421V39C54 38.4477 53.5523 38 53 38H49C48.4477 38 48 38.4477 48 39Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 39V45.7344C6 45.9085 6.04541 46.0795 6.13176 46.2306L13.7121 59.4961C13.8901 59.8077 14.2215 60 14.5803 60H17C17.5523 60 18 60.4477 18 61V65C18 65.5523 17.5523 66 17 66H11.0899C10.7259 66 10.3907 65.8022 10.2147 65.4837L0.124758 47.2258C0.0429249 47.0777 0 46.9113 0 46.7421V39C0 38.4477 0.447716 38 1 38H5C5.55228 38 6 38.4477 6 39Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGear);
export default __webpack_public_path__ + "static/media/newGear.d5e86ee09c97d41db9d54ba55056637a.svg";
export { ForwardRef as ReactComponent };